import { CREATE_PERMISSION } from '../constants/consts';

export const canCreate = permissionLevels => {
  return permissionLevels.includes(CREATE_PERMISSION);
};
